import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as S from './styles';

export default function TabBar({
  onChange,
  children,
  className,
  value,
  styleTab,
}) {
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const [optionSelected, setOptionSelected] = useState(null);
  const barRef = useRef();
  const handleChange = ({ value: valueItem, ref }) => {
    setOptionSelected(ref);
    onChange({ value: valueItem, ref });
  };
  const newChildrens = React.Children.map(children, child => {
    return React.cloneElement(
      child,
      {
        key: child.props.value,
        onChange: handleChange,
        isSelected: value === child.props.value,
        styleButton: styleTab,
      },
      ...children
    );
  });

  const childWidth = optionSelected ? optionSelected.current.clientWidth : null;
  const childLeft = optionSelected ? optionSelected.current.offsetLeft : null;
  const childHeight =
    optionSelected && styleTab && styleTab.withBorder ? '3px' : '100%';
  return (
    <S.NavBar {...styleTab} className={className}>
      <S.SubRouteNavBar
        {...styleTab}
        ref={barRef}
        selectedLeft={childLeft}
        selectedWidth={childWidth}
      >
        <>
          {value && optionSelected && (
            <S.DecorationBar
              {...styleTab}
              selectedLeft={childLeft}
              selectedWidth={childWidth}
              selectedHeight={childHeight}
              competition={match?.competitionId}
            />
          )}
          {newChildrens}
        </>
      </S.SubRouteNavBar>
    </S.NavBar>
  );
}

TabBar.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styleTab: PropTypes.object,
};

TabBar.defaultProps = {
  onChange: () => {},
  children: null,
  className: null,
  value: 0,
  styleTab: {},
};
